import { useRouter } from 'next/router'
import { type FC, useEffect, useState } from 'react'
import { Loader, Box } from '@mantine/core'

export const RouterTransition: FC = () => {
  const router = useRouter()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    let maxWaitTimeout: NodeJS.Timeout | null = null

    const handleStart = (url: string) => {
      if (url !== router.asPath) {
        setIsLoading(true)
      }
    }

    const handleComplete = () => {
      if (maxWaitTimeout) {
        clearTimeout(maxWaitTimeout)
        maxWaitTimeout = null
      }
      setIsLoading(false)
    }

    router.events.on('routeChangeStart', handleStart)
    router.events.on('routeChangeComplete', handleComplete)
    router.events.on('routeChangeError', handleComplete)

    return () => {
      if (maxWaitTimeout) {
        clearTimeout(maxWaitTimeout)
      }
      router.events.off('routeChangeStart', handleStart)
      router.events.off('routeChangeComplete', handleComplete)
      router.events.off('routeChangeError', handleComplete)
    }
  }, [router.asPath, router.events])

  if (!isLoading) {
    return null
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <Loader
        size='xl'
        color='#41BEB2'
        variant='dots'
      />
    </Box>
  )
}
